import gql from "graphql-tag";

const TYPE_EVENTBYGROUPS_QUERY = gql`
  query TypeEventByGroups($groupIDs: [Int]) {
    typeEventByGroups(groupIDs: $groupIDs) {
      value: id
      label: description
    }
  }
`;

export default TYPE_EVENTBYGROUPS_QUERY;
